import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Collapse,
  TextField,
  Skeleton,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Tooltip,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Link,
  InputAdornment,
  alpha,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WifiTetheringOutlinedIcon from "@mui/icons-material/WifiTetheringOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import {
  ASSETICONBASEURL,
  MININGWEBSERVICE,
  POOLWEBSERVICE,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import NetworkHashrateGraph from "./NetworkHashrateGraph";
import { useSelector } from "react-redux";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const MiningPoolPage = () => {
  const theme = localStorage.getItem("theme");
  const [search, setSearch] = useState("");
  const { btncolor, brokerBasicInfo } = useSelector((state) => state);
  const [allPoolHashRates, setAllPoolHashRates] = useState({});
  const [poolDetailsList, setPoolDetailsList] = useState([]);
  const [currencyDetailsList, setCurrencyDetailsList] = useState([]);
  const [inputUnitDetailsList, setInputUnitDetailsList] = useState({});
  const [loading, setLoading] = useState(true);

  const accessToken = localStorage.getItem("access_token");

  const [miningAddress, setMiningAddress] = useState("");
  const [rewardAmount, setRewardAmount] = useState("");
  const [rewardDestinationAddress, setRewardDestinationAddress] = useState("");
  const [inputRate, setInputRate] = useState("");
  const [convertedRate, setConvertedRate] = useState("");
  const [miningAddressTextEnable, setMiningAddressTextEnable] = useState(false);
  const [rewardTransferTextEnable, setRewardTransferTextEnable] = useState(false);
  const [dailyRevenueTextEnable, setDailyRevenueTextEnable] = useState(false);
  const [selectedInputUnit, setSelectedInputUnit] = useState("USD");
  const [poolActionModal, setPoolActionModal] = useState(false);
  const [selectedPoolCoin, setSelectedPoolCoin] = useState("");
  const [selectedPool, setSelectedPool] = useState("");
  const [selectedPoolCoinCurrencyId, setSelectedPoolCoinCurrencyId] = useState("");
  const [miningAddressGenerated, setMiningAddressGenerated] = useState("");
  const [selectedPoolId, setSelectedPoolId] = useState("");
  const [miningAddressModalOpen, setMiningAddressModalOpen] = useState(false);
  const [miningStatusModal, setMiningStatusModal] = useState(false);
  const [blockInfoModal, setBlockInfoModal] = useState(false);
  const [hashRateGraphModal, setHashRateGraphModal] = useState(false);

  const [stpLoader, setStpLoader] = useState(false);
  const [miningStatusResult, setMiningStatusResult] = useState([]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [open, setOpen] = useState(false);
  const [blockInfo, setBlockInfo] = useState(null);
  const [openRowIndex, setOpenRowIndex] = useState(null);
  const [miningPage, setMiningPage] = useState(
    window.location.origin + "/legal/mining-pool-users.html"
  );
  const conversion = [
    { rate: 1e3, unit: "KH/s" },
    { rate: 1e6, unit: "MH/s" },
    { rate: 1e9, unit: "GH/s" },
    { rate: 1e12, unit: "TH/s" },
    { rate: 1e15, unit: "PH/s" },
    { rate: 1e18, unit: "EH/s" },
  ];

  const [noticeModal, setNoticeModal] = useState(false);
  const [firstCheckBox, setFirstCheckBox] = useState(false);
  const [secondCheckBox, setSecondCheckBox] = useState(false);
  const [thirdCheckBox, setThirdCheckBox] = useState(false);

  // Open modal on mount unless third checkbox was previously checked
  useEffect(() => {
    const skipNotice = localStorage.getItem("skipNoticeModalMining");
    if (skipNotice !== "true") {
      setNoticeModal(true);
    }
  }, []);

  // Handle checkbox updates
  const handleFirstCheckbox = (e) => setFirstCheckBox(e.target.checked);
  const handleSecondCheckbox = (e) => setSecondCheckBox(e.target.checked);
  const handleThirdCheckbox = (e) => {
    const checked = e.target.checked;
    setThirdCheckBox(checked);
    localStorage.setItem("skipNoticeModalMining", checked.toString());
  };

  // Button should be disabled unless both first and second are checked
  const isConfirmDisabled = !(firstCheckBox && secondCheckBox);

  const handleConfirm = () => {
    setNoticeModal(false);
  };

  const getCurrencyId = (coin) => {
    console.log("coin", coin);
    const currencyInfo = currencyDetailsList.find(
      (info) => info.CURRENCY === coin
    );
    console.log("currencyInfo", currencyInfo);
    return currencyInfo ? currencyInfo.CURRENCYID : null;
  };

  const inputUnit = (coin) => {
    if (
      inputUnitDetailsList &&
      Object.prototype.hasOwnProperty.call(inputUnitDetailsList, coin)
    ) {
      return inputUnitDetailsList[coin];
    } else {
      return null;
    }
  };

  const getAssetPoolHashRates = (assetName) => {
    let hashRate = 0;
    for (let i = 0; i < allPoolHashRates.length; i++) {
      if (allPoolHashRates[i].coin === assetName.toUpperCase()) {
        hashRate = allPoolHashRates[i].hashrate;
        break;
      } else {
        hashRate = "No poolhashrate found";
      }
    }
    return hashRate;
  };

  const getInputUnit = async () => {
    try {
      const response = await axios.get(`${MININGWEBSERVICE}/getInputUnit`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      });
      setInputUnitDetailsList(response.data);
    } catch (error) {
      console.error("Error fetching input unit:", error);
    }
  };

  const fetchCurrencyPrecision = async () => {
    try {
      const response = await axios.get(`${WEBSERVICE}home/currencyPrecision`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${accessToken}`,
        },
      });
      console.log("Currency precision response:", response.data.precisionList);
      setCurrencyDetailsList(response.data.precisionList);
    } catch (error) {
      console.error("Failed to fetch currency precision:", error);
    }
  };

  const getAllAssetsPoolHashRates = async () => {
    try {
      const url = `${MININGWEBSERVICE}/getAvgPoolHashrate`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${accessToken}`,
        },
      });
      setAllPoolHashRates(response.data);
      getListOfPool(response.data);
    } catch (error) {
      console.error("Error fetching pool hash rates:", error);
    }
  };

  const getListOfPool = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${POOLWEBSERVICE}/pools`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      });

      const poolList = response.data.pools;
      if (poolList?.length > 0) {
        const poolDetails = poolList.map((pool) => {
          const poolPort = pool.ports || {};
          const poolPortDetails = Object.entries(poolPort).map(([key, val]) => ({
            url: `stratum+tcp://poolpaybito.com:${key}`,
            urlName: val.name,
          }));

          const reducedPoolHashRate = getAssetPoolHashRates(pool.coin.symbol);

          return {
            id: pool.id,
            currency: pool.coin.symbol,
            algo: pool.coin.algorithm,
            currencyId: getCurrencyId(pool.coin.symbol),
            poolHashRate: "",
            poolHashRateUnit: conversationUnits(reducedPoolHashRate),
            reducedPoolHashRate: reducedPoolHashRate,
            networkHashRate: pool.networkStats.networkHashrate,
            reducedNetworkHashRate: conversationValue(pool.networkStats.networkHashrate),
            networkHashRateUnit: conversationUnits(pool.networkStats.networkHashrate),
            minimumPayout: pool.paymentProcessing.minimumPayment,
            poolFeePercent: pool.poolFeePercent,
            inputUnit: inputUnit(pool.coin.symbol),
            portList: poolPortDetails,
          };
        });

        console.log("poolDetails", poolDetails);
        setPoolDetailsList(poolDetails);
        setLoading(false);
      } else {
        setPoolDetailsList([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch pool list:", error);
      setLoading(false);
    }
  };

  const generateMiningAddress = async () => {
    const payload = {
      currency: selectedPoolCoin,
      uuid: localStorage.getItem("uuid"),
      customerid: localStorage.getItem("user_id"),
      poolid: selectedPoolId,
    };

    try {
      const response = await axios.post(
        `${MININGWEBSERVICE}/generateMiningAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.address) {
        setMiningAddressGenerated(response.data.address);
        setMiningAddressModalOpen(true);
      } else {
        showToast("error", response.data.message || "Something went wrong");
      }
    } catch (error) {
      showToast("error", "Error generating mining address");
    }
  };

  useEffect(() => {
    getInputUnit();
    fetchCurrencyPrecision();
  }, []);

  useEffect(() => {
    getAllAssetsPoolHashRates();
  }, [currencyDetailsList]);

  const filteredPools = poolDetailsList.filter((pool) =>
    pool.currency.toLowerCase().includes(search.toLowerCase())
  );

  const conversationValue = (value) => {
    const numericValue = Number(value);
    if (isNaN(numericValue)) return "";

    let modifiedValue;
    for (let i = 0; i < conversion.length; i++) {
      const lowerBound = conversion[i].rate;
      const upperBound =
        i === conversion.length - 1
          ? Number.POSITIVE_INFINITY
          : conversion[i + 1].rate;

      if (numericValue === 0) {
        modifiedValue = 0;
        break;
      }
      if (numericValue < lowerBound) {
        modifiedValue = numericValue;
        break;
      }
      if (numericValue >= lowerBound && numericValue < upperBound) {
        modifiedValue = numericValue / lowerBound;
        break;
      }
    }
    return modifiedValue;
  };

  const conversationUnits = (value) => {
    console.log("value", value);
    const numericValue = Number(value);
    if (isNaN(numericValue)) return "";
    for (let i = conversion.length - 1; i >= 0; i--) {
      if (numericValue >= conversion[i].rate) {
        return conversion[i].unit;
      }
    }
    return "H/s";
  };

  const openPoolActionModal = (index) => {
    setSelectedPool(poolDetailsList[index]);
    console.log("poolDetailsList", poolDetailsList[index]);
    setPoolActionModal(true);
    setMiningAddress("");
    setSelectedPoolId(poolDetailsList[index].id);
    setSelectedPoolCoin(poolDetailsList[index].currency);
    setSelectedPoolCoinCurrencyId(poolDetailsList[index].currencyId);
    setMiningAddressTextEnable(false);
    setMiningAddressGenerated("");
    setRewardTransferTextEnable(false);
    setDailyRevenueTextEnable(false);
    setRewardAmount("");
    setRewardDestinationAddress("");
    setSelectedInputUnit(poolDetailsList[index].inputUnit);
    setInputRate(0);
    setConvertedRate(0);
  };

  const checkNodeAddress = async (type, address, amount) => {
    setStpLoader(true);
    const currencyId = selectedPoolCoinCurrencyId;
    const payload = { toAdd: address, currencyId: currencyId };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/checkNodeAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const { error } = response.data;
      if (error?.error_data !== 0) {
        setStpLoader(false);
        showToast("error", error.error_msg || "Invalid address");
      } else {
        if (type === "miningStatus") {
          submitMiningAddress();
        } else if (type === "rewardTransfer") {
          sendMiningToOther(address, amount);
        }
      }
    } catch (err) {
      setStpLoader(false);
      showToast("error", "Failed to verify node address");
    }
  };

  const submitMiningAddress = async () => {
    setStpLoader(true);
    setMiningStatusResult([]);
    try {
      const response = await axios.get(
        `${POOLWEBSERVICE}/pools/${selectedPoolId}/miner/${miningAddress}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const data = response.data;
      if (data.performanceSamples.length != 0) {
        let hashRate, created, sharesPerSecond;

        if (selectedPoolCoin === "XMR") {
          hashRate = data.performance.workers[""]?.hashrate || 0;
          created = data.performance.created;
          sharesPerSecond = data.performance.workers[""]?.sharesPerSecond;
        } else {
          const lastSample =
            data.performanceSamples[data.performanceSamples.length - 1];
          hashRate = lastSample?.workers[""]?.hashrate || 0;
          created = lastSample?.created;
          sharesPerSecond = lastSample?.workers[""]?.sharesPerSecond;
        }

        const hashRateUnit = conversationUnits(hashRate);
        const reducedHashRate = conversationValue(hashRate);

        setMiningStatusResult([
          {
            pendingShares: data.pendingShares,
            pendingBalance: data.pendingBalance,
            totalPaid: data.totalPaid,
            todayPaid: data.todayPaid,
            created,
            hashRate,
            hashRateUnit,
            reducedHashRate,
            sharesPerSecond,
          },
        ]);
      } else {
        setMiningStatusResult([]);
      }
      console.log("Mining status response:");
      setMiningStatusModal(true);
    } catch (err) {
      console.error("Error fetching mining status:", err);
    }
    setStpLoader(false);
  };

  const sendMiningToOther = async (Address, Amount) => {
    setStpLoader(true);
    try {
      const payload = {
        uuid: localStorage.getItem("uuid"),
        poolId: selectedPoolId,
        coin: selectedPoolCoin,
        amount: Amount,
        address: Address,
      };

      const response = await axios.post(
        `${MININGWEBSERVICE}/sendMiningToOther`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error === "success") {
        showToast(
          "success",
          `${rewardAmount} ${selectedPoolCoin} has been successfully transferred!`
        );
      } else {
        showToast("error", response.data.error || "Something went wrong");
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Something went wrong while transferring rewards.",
        severity: "error",
      });
    } finally {
      setStpLoader(false);
    }
  };

  const getBlocksMinedByPool = async () => {
    setStpLoader(true);
    setBlockInfo(null);
    try {
      const response = await axios.get(
        `${POOLWEBSERVICE}/pools/${selectedPoolId}/blocks`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.length > 0) {
        const b = response.data[0];
        setBlockInfo({
          blockHeight: b.blockHeight,
          status: b.status,
          effort: b.effort,
          confirmationProgress: b.confirmationProgress,
          transactionConfirmationData: b.transactionConfirmationData,
          reward: b.reward,
          infoLink: b.infoLink,
          created: b.created,
        });
      }
      setBlockInfoModal(true);
    } catch (error) {
      console.error("Failed to fetch block info", error);
    } finally {
      setStpLoader(false);
    }
  };

  const calculateProfit = async (val) => {
    setInputRate(val);
    const token = localStorage.getItem("access_token");
    const requestData = {
      currency: selectedPoolCoin,
      inputHashRate: val,
    };

    try {
      const response = await axios.post(
        `${MININGWEBSERVICE}/calculateProfit`,
        JSON.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      if (response.data && response.data.calculatedValue !== undefined) {
        setConvertedRate(response.data.calculatedValue);
      }
    } catch (error) {
      console.error("Error calculating profit:", error);
    }
  };

  const getMiningInstruction = () => {
    const url =
      window.location.origin +
      "/" +
      selectedPoolCoin.toLowerCase() +
      "-mining-instruction/";
    window.open(url, "_blank");
  };

  // ── Table columns ─────────────────────────────────────────────────────────
  const tableColumns = [
    "",
    "Coin",
    "Algorithm",
    "Pool Hashrate",
    "Network Hashrate",
    "Min Payout",
    "Fee",
    "Actions",
  ];

  // ── Action buttons for pool modal ─────────────────────────────────────────
  const poolActions = [
    {
      label: `Generate ${selectedPoolCoin} Mining Address`,
      onClick: () => generateMiningAddress(),
      expandKey: null,
    },
    {
      label: "Check Your Mining Status",
      onClick: () => setMiningAddressTextEnable(!miningAddressTextEnable),
      expandKey: "miningAddress",
    },
    {
      label: "Pool Block Information",
      onClick: () => getBlocksMinedByPool(),
      expandKey: null,
    },
    {
      label: "Reward Transfer",
      onClick: () => setRewardTransferTextEnable(!rewardTransferTextEnable),
      expandKey: "rewardTransfer",
    },
    {
      label: "Estimate Daily Revenue",
      onClick: () => setDailyRevenueTextEnable(!dailyRevenueTextEnable),
      expandKey: "dailyRevenue",
    },
    {
      label: "Mining Instructions",
      onClick: () => getMiningInstruction(),
      expandKey: null,
    },
    {
      label: "View Network Hashrate Graph",
      onClick: () => setHashRateGraphModal(true),
      expandKey: null,
    },
  ];

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <WifiTetheringOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>
              {brokerBasicInfo?.exchange || ""} Mining Pool
            </Typography>
            <Typography sx={heroSubtitle}>
              Get more rewards by connecting to the pool — track hashrates,
              manage addresses and estimate daily revenue.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>
        {/* Search bar */}
        <Box sx={searchBar}>
          <TextField
            placeholder="Search by coin..."
            variant="outlined"
            size="small"
            value={search}
            autoComplete="off"
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlinedIcon
                    sx={{ fontSize: 18, color: "var(--text-color)", opacity: 0.45 }}
                  />
                </InputAdornment>
              ),
            }}
            sx={searchFieldStyle}
          />
        </Box>

        {/* Pool Table */}
        <TableContainer sx={modernTableContainer}>
          <Table sx={tableStyle}>
            <TableHead>
              <TableRow sx={modernTableHeadRow}>
                {tableColumns.map((col, i) => (
                  <TableCell key={i} sx={modernTableHeadCell}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading
                ? Array.from({ length: 5 }).map((_, index) => (
                    <TableRow key={index}>
                      {tableColumns.map((_, ci) => (
                        <TableCell key={ci}>
                          <Skeleton
                            variant={ci === 0 ? "circular" : "text"}
                            width={ci === 0 ? 24 : "70%"}
                            height={ci === 0 ? 24 : 20}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : filteredPools.length > 0
                ? filteredPools.map((row, index) => (
                    <React.Fragment key={index}>
                      <TableRow sx={modernTableBodyRow}>
                        <TableCell sx={{ ...modernTableBodyCell, width: 40, pr: 0 }}>
                          {row.portList?.length > 0 && (
                            <Tooltip
                              title={
                                openRowIndex === index
                                  ? "Collapse ports"
                                  : "View stratum ports"
                              }
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  setOpenRowIndex(
                                    openRowIndex === index ? null : index
                                  )
                                }
                                sx={{ color: "var(--text-color)", opacity: 0.6 }}
                              >
                                {openRowIndex === index ? (
                                  <KeyboardArrowUpIcon fontSize="small" />
                                ) : (
                                  <KeyboardArrowDownIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Avatar
                              src={`${ASSETICONBASEURL}${row.currency}.png`}
                              alt={row.currency}
                              sx={{ width: 26, height: 26 }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.88rem",
                                fontWeight: 700,
                                color: "var(--text-color)",
                              }}
                            >
                              {row.currency}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          <Box sx={algoPill}>{row.algo}</Box>
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          {row.reducedPoolHashRate === "No poolhashrate found"
                            ? "—"
                            : `${conversationValue(row.reducedPoolHashRate)} ${conversationUnits(
                                row.reducedPoolHashRate
                              )}`}
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          {row.reducedNetworkHashRate} {row.networkHashRateUnit}
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          {row.minimumPayout}
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          <Box sx={feePill}>{row.poolFeePercent}%</Box>
                        </TableCell>

                        <TableCell sx={modernTableBodyCell}>
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() => openPoolActionModal(index)}
                            sx={{
                              height: 32,
                              px: 2,
                              borderRadius: "8px",
                              textTransform: "none",
                              fontWeight: 600,
                              fontSize: "0.78rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            More
                          </ContainedButton>
                        </TableCell>
                      </TableRow>

                      {/* Expandable ports row */}
                      {row.portList?.length > 0 && (
                        <TableRow>
                          <TableCell
                            colSpan={tableColumns.length}
                            sx={{ p: 0, borderBottom: 0 }}
                          >
                            <Collapse
                              in={openRowIndex === index}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box sx={expandedPortsWrap}>
                                <Typography sx={expandedPortsTitle}>
                                  Stratum Ports
                                </Typography>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={subTableHeadCell}>
                                        Name
                                      </TableCell>
                                      <TableCell sx={subTableHeadCell}>
                                        URL
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {row.portList.map((data, pi) => (
                                      <TableRow key={pi}>
                                        <TableCell sx={subTableBodyCell}>
                                          {data.urlName}
                                        </TableCell>
                                        <TableCell sx={subTableBodyCell}>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: "0.82rem",
                                                fontFamily: "monospace",
                                                color: "var(--text-color)",
                                              }}
                                            >
                                              {data.url}
                                            </Typography>
                                            <Tooltip title="Copy URL">
                                              <IconButton
                                                size="small"
                                                sx={{
                                                  color: "var(--text-color)",
                                                  opacity: 0.55,
                                                }}
                                                onClick={() => {
                                                  navigator.clipboard.writeText(
                                                    data.url
                                                  );
                                                  showToast(
                                                    "success",
                                                    "Copied to clipboard"
                                                  );
                                                }}
                                              >
                                                <ContentCopyIcon
                                                  sx={{ fontSize: 14 }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                : (
                  <TableRow>
                    <TableCell colSpan={tableColumns.length} sx={emptyCell}>
                      <InboxOutlinedIcon sx={emptyIcon} />
                      <Typography sx={emptyText}>No pools found</Typography>
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Pool Action Modal                                                   */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={poolActionModal}
        onClose={() => setPoolActionModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Box
            sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}
          >
            {selectedPoolCoin && (
              <img
                src={`${ASSETICONBASEURL}${selectedPoolCoin}.png`}
                alt={selectedPoolCoin}
                width={20}
                height={20}
                style={{ borderRadius: "50%" }}
              />
            )}
            Mining Pool Actions
          </Box>
          <IconButton
            onClick={() => setPoolActionModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {poolActions.map((action, i) => (
              <OutlinedButton
                key={i}
                variant="outlined"
                fullWidth
                onClick={action.onClick}
                sx={actionOutlinedBtn}
              >
                {action.label}
              </OutlinedButton>
            ))}

            {/* Mining Status input */}
            {miningAddressTextEnable && (
              <Box sx={expandedSection}>
                <Typography sx={sectionFieldLabel}>Enter Mining Address</Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={miningAddress}
                  onChange={(e) => setMiningAddress(e.target.value)}
                  error={!miningAddress}
                  helperText={!miningAddress ? "Mining Address is required" : ""}
                  sx={dialogTextField}
                />
                {selectedPoolCoin === "BCH" && (
                  <Typography sx={{ fontSize: "0.78rem", color: "#ef4444", mt: 0.75 }}>
                    Paste your legacy BCH mining address
                  </Typography>
                )}
                <ContainedButton
                  variant="contained"
                  fullWidth
                  disabled={!miningAddress || stpLoader}
                  onClick={() => checkNodeAddress("miningStatus", miningAddress, "")}
                  sx={{ mt: 1.5, height: 40, borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
                >
                  {stpLoader ? (
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                  ) : (
                    "Confirm"
                  )}
                </ContainedButton>
              </Box>
            )}

            {/* Reward Transfer inputs */}
            {rewardTransferTextEnable && (
              <Box sx={expandedSection}>
                <Typography sx={sectionFieldLabel}>Enter Amount</Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={rewardAmount}
                  onChange={(e) => setRewardAmount(e.target.value)}
                  error={!rewardAmount}
                  helperText={!rewardAmount ? "Amount is required" : ""}
                  sx={dialogTextField}
                />
                <Typography sx={{ ...sectionFieldLabel, mt: 1.5 }}>
                  Enter Destination Address
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={rewardDestinationAddress}
                  onChange={(e) => setRewardDestinationAddress(e.target.value)}
                  error={!rewardDestinationAddress}
                  helperText={
                    !rewardDestinationAddress
                      ? "Reward Destination Address is required"
                      : ""
                  }
                  sx={dialogTextField}
                />
                <ContainedButton
                  variant="contained"
                  fullWidth
                  sx={{ mt: 1.5, height: 40, borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
                  disabled={!rewardAmount || !rewardDestinationAddress || stpLoader}
                  onClick={() =>
                    checkNodeAddress(
                      "rewardTransfer",
                      rewardDestinationAddress,
                      rewardAmount
                    )
                  }
                >
                  {stpLoader ? (
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                  ) : (
                    "Confirm"
                  )}
                </ContainedButton>
              </Box>
            )}

            {/* Daily Revenue inputs */}
            {dailyRevenueTextEnable && (
              <Box sx={expandedSection}>
                <Typography sx={sectionFieldLabel}>
                  Estimate Earnings ({selectedInputUnit})
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto 1fr",
                    gap: 1.5,
                    alignItems: "center",
                    mt: 0.5,
                  }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    value={inputRate}
                    onChange={(e) => calculateProfit(e.target.value)}
                    placeholder={`Rate in ${selectedInputUnit}`}
                    sx={dialogTextField}
                  />
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 700,
                      color: "var(--text-color)",
                      opacity: 0.4,
                      textAlign: "center",
                    }}
                  >
                    →
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={convertedRate}
                    InputProps={{ readOnly: true }}
                    sx={dialogTextField}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    color: "var(--text-color)",
                    opacity: 0.5,
                    textAlign: "center",
                    mt: 1,
                  }}
                >
                  Conversion from {selectedInputUnit} to {selectedPoolCoin}
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2, backgroundColor: "var(--popupbody-color)" }}>
          <ContainedButton
            variant="contained"
            onClick={() => setPoolActionModal(false)}
            sx={{ height: 40, px: 3, borderRadius: "10px", textTransform: "none", fontWeight: 600, minWidth: 100 }}
          >
            Close
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Mining Address Modal                                                */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={miningAddressModalOpen}
        onClose={() => setMiningAddressModalOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Box
            sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}
          >
            {selectedPoolCoin && (
              <img
                src={`${ASSETICONBASEURL}${selectedPoolCoin}.png`}
                alt={selectedPoolCoin}
                width={20}
                height={20}
                style={{ borderRadius: "50%", marginRight: 4 }}
              />
            )}
            {selectedPoolCoin} Mining Address
          </Box>
          <IconButton
            onClick={() => setMiningAddressModalOpen(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={{ ...dialogContentStyle, pt: 3 }}>
          <Box sx={addressBox}>
            <Typography sx={addressText}>{miningAddressGenerated}</Typography>
            <Tooltip title="Copy address">
              <IconButton
                size="small"
                sx={{ color: "var(--text-color)", opacity: 0.6, flexShrink: 0 }}
                onClick={() => {
                  navigator.clipboard.writeText(miningAddressGenerated);
                  showToast("success", "Copied to clipboard");
                }}
              >
                <ContentCopyIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {selectedPoolCoin === "BCH" && (
            <Typography
              sx={{
                fontSize: "0.82rem",
                color: "var(--text-color)",
                opacity: 0.75,
                mt: 2,
                lineHeight: 1.65,
              }}
            >
              Please copy the above BCH address and convert it into a legacy BCH
              address using{" "}
              <a
                href="https://bch.info/en/tools/cashaddr"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600 }}
              >
                Legacy
              </a>
              . Use this legacy address only at the time of mining.
            </Typography>
          )}
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2, backgroundColor: "var(--popupbody-color)" }}>
          <OutlinedButton
            variant="outlined"
            onClick={() => setMiningAddressModalOpen(false)}
            sx={{ height: 40, px: 3, borderRadius: "10px", textTransform: "none", fontWeight: 600, minWidth: 100 }}
          >
            Close
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Mining Status Modal                                                 */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={miningStatusModal}
        onClose={() => setMiningStatusModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Mining Status
          <IconButton
            onClick={() => setMiningStatusModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          {stpLoader ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={32} />
            </Box>
          ) : miningStatusResult.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <InboxOutlinedIcon sx={{ fontSize: 42, color: "var(--text-color)", opacity: 0.3, mb: 1 }} />
              <Typography sx={{ fontSize: "0.88rem", color: "var(--text-color)", opacity: 0.6 }}>
                Mining status for{" "}
                <Box
                  component="img"
                  src={`${ASSETICONBASEURL}${selectedPoolCoin.toUpperCase()}.png`}
                  alt={selectedPoolCoin}
                  sx={{ width: 16, height: 16, verticalAlign: "middle", mx: 0.5 }}
                />
                <strong>{selectedPoolCoin}</strong> — address{" "}
                <strong>{miningAddress}</strong> not found.
              </Typography>
            </Box>
          ) : (
            <TableContainer sx={statusTableContainer}>
              <Table size="small">
                <TableBody>
                  {[
                    {
                      label: "Coin",
                      value: (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <img
                            src={`${ASSETICONBASEURL}${selectedPoolCoin.toUpperCase()}.png`}
                            alt={selectedPoolCoin}
                            width={18}
                            height={18}
                          />
                          {selectedPoolCoin}
                        </Box>
                      ),
                    },
                    { label: "Mining Address", value: miningAddress },
                    {
                      label: "Pending Shares",
                      value: miningStatusResult[0].pendingShares?.toFixed(2),
                    },
                    {
                      label: "Pending Balance",
                      value: miningStatusResult[0].pendingBalance?.toFixed(2),
                    },
                    {
                      label: "Total Paid",
                      value: miningStatusResult[0].totalPaid?.toFixed(2),
                    },
                    {
                      label: "Today Paid",
                      value: miningStatusResult[0].todayPaid?.toFixed(2),
                    },
                    { label: "Created On", value: miningStatusResult[0].created },
                    {
                      label: "Hashrate",
                      value: `${miningStatusResult[0].reducedHashRate?.toFixed(2)} ${miningStatusResult[0].hashRateUnit}`,
                    },
                    {
                      label: "Shares Per Second",
                      value: miningStatusResult[0].sharesPerSecond,
                    },
                  ].map((row, i) => (
                    <TableRow key={i} sx={statusTableRow}>
                      <TableCell sx={statusLabelCell}>{row.label}</TableCell>
                      <TableCell sx={statusValueCell}>{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2, backgroundColor: "var(--popupbody-color)" }}>
          <OutlinedButton
            variant="outlined"
            onClick={() => setMiningStatusModal(false)}
            sx={{ height: 40, px: 3, borderRadius: "10px", textTransform: "none", fontWeight: 600, minWidth: 100 }}
          >
            Close
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Block Info Modal                                                    */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={blockInfoModal}
        onClose={() => setBlockInfoModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            Block Info
          </Box>
          <IconButton
            onClick={() => setBlockInfoModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          {stpLoader ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={32} />
            </Box>
          ) : blockInfo ? (
            <TableContainer sx={statusTableContainer}>
              <Table size="small">
                <TableBody>
                  {[
                    {
                      label: "Coin",
                      value: (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <img
                            src={`${ASSETICONBASEURL}${selectedPoolCoin.toUpperCase()}.png`}
                            alt={selectedPoolCoin}
                            width={18}
                            height={18}
                          />
                          {selectedPoolCoin}
                        </Box>
                      ),
                    },
                    { label: "Block Height", value: blockInfo.blockHeight },
                    { label: "Status", value: blockInfo.status },
                    { label: "Effort", value: blockInfo.effort },
                    { label: "Confirmation Progress", value: blockInfo.confirmationProgress },
                    {
                      label: "Transaction Confirmation Data",
                      value: blockInfo.transactionConfirmationData,
                    },
                    { label: "Reward", value: blockInfo.reward },
                    {
                      label: "Info Link",
                      value: (
                        <a
                          href={blockInfo.infoLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "var(--text-color)", fontWeight: 600 }}
                        >
                          {blockInfo.infoLink}
                        </a>
                      ),
                    },
                    { label: "Created On", value: blockInfo.created },
                  ].map((row, i) => (
                    <TableRow key={i} sx={statusTableRow}>
                      <TableCell sx={statusLabelCell}>{row.label}</TableCell>
                      <TableCell sx={statusValueCell}>{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <InboxOutlinedIcon sx={{ fontSize: 42, color: "var(--text-color)", opacity: 0.3, mb: 1 }} />
              <Typography sx={{ fontSize: "0.88rem", color: "var(--text-color)", opacity: 0.6 }}>
                Blocks mined by{" "}
                <Box
                  component="img"
                  src={`${ASSETICONBASEURL}${selectedPoolCoin.toUpperCase()}.png`}
                  alt={selectedPoolCoin}
                  sx={{ width: 16, height: 16, verticalAlign: "middle", mx: 0.5 }}
                />
                <strong>{selectedPoolCoin}</strong> not found.
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Hashrate Graph Modal                                                */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={hashRateGraphModal}
        onClose={() => setHashRateGraphModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            {selectedPoolCoin && (
              <img
                src={`${ASSETICONBASEURL}${selectedPoolCoin.toUpperCase()}.png`}
                alt={selectedPoolCoin}
                width={20}
                height={20}
                style={{ borderRadius: "50%" }}
              />
            )}
            {selectedPoolCoin} Network Hashrate
          </Box>
          <IconButton
            onClick={() => setHashRateGraphModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogContent sx={{ ...dialogContentStyle, pt: 2 }}>
          <NetworkHashrateGraph selectedPoolCoin={selectedPoolCoin} />
        </DialogContent>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* Notice Modal                                                        */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={noticeModal}
        onClose={() => setNoticeModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Notice
          <IconButton
            onClick={() => setNoticeModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          <Typography
            sx={{ fontSize: "0.88rem", fontWeight: 600, color: "var(--text-color)", mb: 1.5 }}
          >
            I acknowledge that:
          </Typography>

          <Box
            sx={{
              backgroundColor: "var(--body-color)",
              borderRadius: "10px",
              border: "1px solid rgba(125,125,125,0.15)",
              p: 2,
              mb: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            <Typography sx={noticeItemText}>
              <strong>1.</strong> The mining process is very demanding on the
              computing power of my hardware, which can cause an increase in
              electricity consumption and accelerate wear on some hardware.
            </Typography>
            <Divider sx={{ borderColor: "rgba(125,125,125,0.1)" }} />
            <Typography sx={noticeItemText}>
              <strong>2.</strong> It is my responsibility to set up my software
              and hardware, including any individual components. I confirm that
              my Mining Hardware has been acquired using my own legitimate funds
              in accordance with Applicable Laws.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={firstCheckBox}
                  onChange={handleFirstCheckbox}
                  size="small"
                  sx={{ color: "var(--text-color)", "& .MuiSvgIcon-root": { fontSize: 18 } }}
                />
              }
              label={
                <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                  I understand and agree to the above statements
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={secondCheckBox}
                  onChange={handleSecondCheckbox}
                  size="small"
                  sx={{ color: "var(--text-color)", "& .MuiSvgIcon-root": { fontSize: 18 } }}
                />
              }
              label={
                <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>
                  I understand and agree to the{" "}
                  <Link href={miningPage} target="_blank" rel="noopener">
                    mining terms of use
                  </Link>
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={thirdCheckBox}
                  onChange={handleThirdCheckbox}
                  size="small"
                  sx={{ color: "var(--text-color)", "& .MuiSvgIcon-root": { fontSize: 18 } }}
                />
              }
              label={
                <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)", opacity: 0.65 }}>
                  Do not show this to me again
                </Typography>
              }
            />
          </Box>
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2, backgroundColor: "var(--popupbody-color)" }}>
          <ContainedButton
            fullWidth
            variant="contained"
            size="large"
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
            sx={{ height: 44, borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const searchBar = {
  px: { xs: 2, md: 2.5 },
  py: 2,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  backgroundColor: "var(--body-color-less2)",
};

const searchFieldStyle = {
  maxWidth: 320,
  "& .MuiInputBase-root": {
    height: "40px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiInputBase-input::placeholder": { opacity: 0.45 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
};

// Table
const modernTableContainer = {
  borderRadius: 0,
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 750,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const algoPill = {
  display: "inline-flex",
  alignItems: "center",
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.65,
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.18)",
  borderRadius: "6px",
  px: 1,
  py: 0.25,
  letterSpacing: "0.04em",
};

const feePill = {
  display: "inline-flex",
  alignItems: "center",
  fontSize: "0.78rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.8,
};

// Expanded ports section
const expandedPortsWrap = {
  mx: 2,
  my: 1.5,
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less2)",
};

const expandedPortsTitle = {
  fontSize: "0.68rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.09em",
  color: "var(--text-color)",
  opacity: 0.45,
  px: 2,
  pt: 1.25,
  pb: 0.75,
};

const subTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.68rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.6,
  py: 1,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  backgroundColor: "var(--body-color-less2)",
};

const subTableBodyCell = {
  fontSize: "0.82rem",
  py: 1,
  color: "var(--text-color)",
  borderBottom: "1px solid rgba(125,125,125,0.08)",
};

// Empty state
const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.3,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.55,
};

// Dialogs
const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "88%", sm: 460 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.05rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.6,
};

const dialogContentStyle = {
  backgroundColor: "var(--popupbody-color)",
  py: 2.5,
  px: { xs: 2, md: 2.5 },
};

const dialogTextField = {
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.6 },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
};

const sectionFieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.55,
  mb: 0.75,
};

const expandedSection = {
  backgroundColor: "var(--body-color)",
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.15)",
  p: 2,
};

const actionOutlinedBtn = {
  height: 44,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
  borderColor: "rgba(125,125,125,0.25)",
  color: "var(--text-color)",
  justifyContent: "flex-start",
  px: 2,
  "&:hover": {
    borderColor: "rgba(125,125,125,0.5)",
    backgroundColor: "var(--body-color)",
  },
};

// Mining address display
const addressBox = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  backgroundColor: "var(--body-color)",
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.18)",
  p: 2,
};

const addressText = {
  flex: 1,
  fontSize: "0.85rem",
  fontFamily: "monospace",
  color: "var(--text-color)",
  wordBreak: "break-all",
  lineHeight: 1.6,
};

// Status / block info table
const statusTableContainer = {
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
  boxShadow: "none",
};

const statusTableRow = {
  "&:last-child td": { borderBottom: 0 },
};

const statusLabelCell = {
  fontSize: "0.78rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.55,
  width: "40%",
  py: 1.5,
  backgroundColor: "var(--body-color-less2)",
  borderBottom: "1px solid rgba(125,125,125,0.1)",
  whiteSpace: "nowrap",
};

const statusValueCell = {
  fontSize: "0.85rem",
  color: "var(--text-color)",
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.1)",
};

// Notice modal
const noticeItemText = {
  fontSize: "0.82rem",
  color: "var(--text-color)",
  opacity: 0.75,
  lineHeight: 1.65,
};

export default MiningPoolPage;
